module.exports = __webpack_public_path__ + "img/screw@3x.99abf824.png";